import { render, staticRenderFns } from "./GridEvidencia.vue?vue&type=template&id=97d6b47e&"
import script from "./GridEvidencia.vue?vue&type=script&lang=js&"
export * from "./GridEvidencia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports